var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"insanityContainer"},[_c('img',{staticStyle:{"width":"100%"},attrs:{"src":"http://fc06.deviantart.net/fs71/f/2013/279/b/a/bodybuilding_motivation______1920x1080_by_xjixsaw-d6pc5w5.jpg"}}),_vm._v(" "),_c('listOfVideos')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cce7ad98","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/Dynamic/app/videos_insanity/main.vue
// module id = 631
// module chunks = 0